import { render, staticRenderFns } from "./AttributeGroupTable.vue?vue&type=template&id=3c27e94d&scoped=true"
import script from "./AttributeGroupTable.vue?vue&type=script&lang=js"
export * from "./AttributeGroupTable.vue?vue&type=script&lang=js"
import style0 from "./AttributeGroupTable.vue?vue&type=style&index=0&id=3c27e94d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27e94d",
  null
  
)

export default component.exports